<template>
  <v-card v-loading class="title" height="260">
    <v-subheader>
      Nuovi clienti a cui è stato emesso un documento intestato
    </v-subheader>
    <div class="display-2">{{ nuoviClienti }}</div>
  </v-card>
</template>

<script>
import stats from '@/mixins/stats';

export default {
  name: 'nuovi-clienti',
  mixins: [stats],
  methods: {
    async refresh(type = null) {
      if (type === 'SESSION' || type === 'LOCALI') {
        await this.nuoviClientiReload();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.v-card
  display flex
  justify-content center
  align-items center
  .v-subheader
    position absolute
    top 0
    left 0
</style>
